export const normalizeNumber = (number) => {
  if (/^(sips?|tel):/i.test(number)) {
    return number;
  } else if (/@/i.test(number)) {
    return number;
  } else {
    return number.replace(/[+1]/g, "");
  }
};

export const formatPhoneNumber = (phoneNumberString) => {
  const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  const match = cleaned.match(/^(\d{1,3}|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? `+${match[1]} ` : "";

    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }

  return phoneNumberString;
};

export const formatToSeconds = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;
  if (hours > 0) {
    return `${hours}h ${minutes}min`;
  } else {
    return `${minutes}min ${remainingSeconds}sec`;
  }
};

export const formatDate = (inputDate) => {
  // Create a Date object
  const date = new Date(inputDate);

  // Define options for formatting
  const options = {
    day: "numeric",
    month: "short", // Use "short" for abbreviated month names
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  // Format the date
  const formattedDate = date.toLocaleString("en-US", options);

  // Extract the day, month, and year
  const dayMonthYear = date.toLocaleString("en-US", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  // Extract the time
  const time = date.toLocaleString("en-US", { hour: "numeric", minute: "numeric", hour12: true });

  // Combine the formatted parts
  const finalFormattedDate = `${dayMonthYear}, ${time}`;

  return finalFormattedDate;
};

export const pad = (val) => (val > 9 ? val : "0" + val); // eslint-disable-line prefer-template

export const getObjectCount = (obj) => Object.keys(obj).length;
